import { chiliTrackApi } from './chili-track-api'

export interface Mixpanel {
  identify: (id: string) => void
  init: (key: string) => void
  people: {
    increment: (name: string) => void
    set: (data: object) => void
    set_once: (data: object) => void
  }
  register: (data: object) => void
  track: (name: string, data?: any) => void
}

export class ChiliMixpanel implements Mixpanel {
  private currentUserId = ''
  private token = ''
  private superProps = {}

  people = {
    set: (data: object) => {
      chiliTrackApi.post('/mp/people/set', {
        data: { userId: this.currentUserId, token: this.token, ...data },
      })
    },
    increment: (name: string) => {
      chiliTrackApi.post('/mp/people/increment', {
        data: { userId: this.currentUserId, token: this.token, name },
      })
    },
    set_once: (data: object) => {
      chiliTrackApi.post('/mp/people/set-once', {
        data: { userId: this.currentUserId, token: this.token, ...data },
      })
    },
  }

  init(key: string) {
    this.token = key
  }

  track(name: string, data: any = {}) {
    chiliTrackApi.post('/mp/track', {
      name,
      data: {
        token: this.token,
        ...(this.currentUserId ? { userId: this.currentUserId } : {}),
        ...this.superProps,
        ...data,
      },
    })
  }

  identify(id: string) {
    this.currentUserId = id
  }

  register(props: object) {
    this.superProps = {
      ...this.superProps,
      ...props,
    }
  }
}

export const chiliMixpanel = new ChiliMixpanel()
